/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";

import { ImageFit } from "@vienna/common";

import { ImageBlock } from "src/classes/block/block-types";
import { MenuBreak } from "src/components/UI/Menus/MenuItem/MenuBreak";
import { MenuItem } from "src/components/UI/Menus/MenuItem/MenuItem";
interface Props {
  block: ImageBlock;
}
export function ImageMenuItems({ block }: Props) {
  const imageFit = block.observe((state) => state.imageFit);
  return (
    <>
      <MenuBreak />
      <MenuItem handleClick={() => block.createCaption()}>Add Caption</MenuItem>
      <MenuItem handleClick={() => block.changeImageFit()} checkmarked={imageFit === ImageFit.Cover}>
        Fill Block
      </MenuItem>
    </>
  );
}
